import {
    Flex,
    useColorModeValue as colorValue
} from '@chakra-ui/react'
import Login from './Login'
import BuildingList from '../components/home/BuildingList'
import UpdateContactNotice from '../components/home/UpdateContactNotice';


const Home = () => {
    return (
        <Flex w="100%" direction="column" bgColor={colorValue("gray.100", "gray.700")}>
            <Login />
            <UpdateContactNotice />
            <BuildingList />
        </Flex>
    )
}

export default Home
